<template>
    <v-layout column wrap>
        <!-- CHATBOT PANEL -->
        <ChatbotPanel></ChatbotPanel>

        <v-flex xs12 pl-1 py-1 pr-3>
            <v-layout row wrap align-center justify-center>
                <v-flex grow>
                    <v-layout row wrap align-center justify-center>
                        <v-chip color="primary" text-color="white" @click="navigate(settingsPath)">
                            <template>
                                <v-flex shrink>
                                    <v-avatar size="12px">
                                        <v-img :src="userSettings.chatbot.language.current.image"/>
                                    </v-avatar>
                                </v-flex>
                                <v-flex grow class="hidden-sm-and-down">
                                    Language and other settings
                                </v-flex>
                            </template>
                        </v-chip>
                    </v-layout>
                </v-flex>

                <!-- DIALOGIC PLATFORM SETTINGS -->
                <v-flex shrink>
                    <v-tooltip color="amber lighten-4" v-model="userChatOptions.activateTooltip" bottom>
                        <template v-slot:activator="{ on }">
                        <v-btn class="ma-0" icon flat v-on="on"
                               @click="openCustomPanel()"
                        >
                            <v-icon color="green">mdi-check-circle</v-icon>
                        </v-btn>
                        </template>
                        <v-card color="amber lighten-4" elevation="0">
                            <!--<v-card-actions>
                                <v-spacer></v-spacer>
                                    <v-icon @click="userChatOptions.activateTooltip=false">mdi-close-circle</v-icon>
                            </v-card-actions>-->
                            <v-card-title>
                                <v-layout column wrap>
                                    <v-flex>
                                        <span v-if="userSettings.chatbot.language.current.locale === 'it'" class="subheading">Qui puoi visualizzare i risultati.</span>
                                        <span v-else class="subheading">Here you can visualize your results.</span>
                                        <v-icon class="pl-2" @click="userChatOptions.activateTooltip=false">mdi-close-circle</v-icon>
                                    </v-flex>
                                    <v-flex>
                                        <span v-if="userSettings.chatbot.language.current.locale === 'it'" class="subheading">Clicca l'icona </span>
                                        <span v-else class="subheading">Click the icon </span>
                                        <v-icon color="green">mdi-check-circle</v-icon>
                                    </v-flex>
                                </v-layout>

                            </v-card-title>

                        </v-card>
                    </v-tooltip>
                    <!--<v-btn class="ma-0" icon flat
                           @click="navigate(settingsPath)"
                    >
                        <v-icon>mdi-settings</v-icon>
                    </v-btn>-->

                    <v-tooltip color="amber lighten-4" bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn class="ma-2"
                                   round color="primary"
                                   dark
                                   small
                                   @click="doOperation('dialogicPlatformReset')"
                                   v-on="on"
                            >
                                Reset
                            </v-btn>
                        </template>
                        <v-card color="amber lighten-4" elevation="0">
                            <v-card-title>
                                <v-layout column wrap>
                                    <v-flex>
                                        <span v-if="userSettings.chatbot.language.current.locale === 'it'" class="subheading">Clicca per effettuare il reset della conversazione.</span>
                                        <span v-else class="subheading">Click to reset the conversation.</span>
                                    </v-flex>
                                    <v-flex>
                                        <span v-if="userSettings.chatbot.language.current.locale === 'it'" class="subheading">Verranno annullati i filtri precedentemente applicati.</span>
                                        <span v-else class="subheading">Previously applied filters will be canceled.</span>
                                    </v-flex>
                                </v-layout>
                            </v-card-title>
                        </v-card>
                    </v-tooltip>
                    <!-- MORE FEATURES -->
                    <!--
                    <v-menu bottom left>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                    class="ma-0"
                                    icon
                                    v-on="on"
                            >
                                <v-icon>more_vert</v-icon>
                            </v-btn>
                        </template>

                        <v-list>
                            <v-list-tile
                                    v-for="(feature, i) in features"
                                    :key="i"
                                    @click="doOperation(feature.action)"
                            >
                                <v-list-tile-title>{{ feature.name }}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                    -->
                </v-flex>
            </v-layout>
        </v-flex>

    </v-layout>
</template>

<script>
    import {mapGetters, mapState} from "vuex";
    import RouterService from "@/helpers/RouterService";
    import ChatbotPanel from './ChatbotPanel';

    export default {
        name: "Subheader",
        props: ["activateTooltip"],
        components: { ChatbotPanel },
        data() {
            return {
                showTooltip: false,
                settingsPath: {
                    name: 'Settings',
                    params: {
                        categoryId: 0
                    }
                },
                features: [
                    {
                        name: "Reset",
                        action: "dialogicPlatformReset",
                    },
                ],
            };
        },
        computed: {
            ...mapState({}),
            ...mapGetters("ChatbotState", {
                    settings: "getSettings",
                    userChatOptions: "getUserChatOptions"
                }
            ),
            ...mapGetters("UserState", {
                    userSettings: "getSettings",
                }
            ),
        },
        methods: {
            navigate(path) {
                this.userChatOptions.activateTooltip = false;
                this.$store.dispatch("ChatbotState/setUserChatOptions", this.userChatOptions);
                RouterService.goTo(path);
            },
            doOperation(action) {
                this.$emit(action);
            },
            openCustomPanel() {
                this.userChatOptions.isCustomPanelOpen = !this.userChatOptions.isCustomPanelOpen;
                this.$store.dispatch("ChatbotState/setUserChatOptions", this.userChatOptions);
            }
        },
    };
</script>

<style lang="scss" scoped>
    .v-btn--floating .v-btn__content > :not(:only-child):last-child,
    .v-btn--floating .v-btn__content > :not(:only-child):first-child {
        position: absolute!important;
        top: -8px!important;
    }


</style>
